function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as t } from "./index.es33.js";
import { useState as y } from "react";
import { clsx as s } from "./index.es105.js";
import { t as N } from "./index.es106.js";
import { Typography as a } from "./index.es35.js";
import { palette as f } from "./index.es36.js";
import { Icon as n } from "./index.es7.js";
import "./index.es133.js";
import "react-dom";
import "./index.es134.js";
import { TimeZoneDate as D } from "./index.es506.js";
import { Month as b } from "./index.es523.js";
import { MonthYearPicker as u } from "./index.es524.js";
import { SIGN_MINUS as S, SIGN_PLUS as k } from "./index.es528.js";
import { monthTranslationKeys as B } from "./index.es529.js";
import o from "./index.es530.js";
import i from "./index.es527.js";
var E = function E(_ref) {
  var l = _ref.date,
    x = _ref.isDateDisabled,
    j = _ref.onSelect;
  var _y = y("dates"),
    _y2 = _slicedToArray(_y, 2),
    e = _y2[0],
    c = _y2[1],
    _y3 = y(function () {
      return l || new D();
    }),
    _y4 = _slicedToArray(_y3, 2),
    r = _y4[0],
    d = _y4[1],
    w = r.getFullYear(),
    h = function h(m) {
      d(m), e !== "dates" && c("dates");
    },
    p = function p(m) {
      d(new Date(new Date(r).setMonth(r.getMonth() + m * (e === "years" ? 12 : 1))));
    };
  return t.jsxs("div", {
    className: o.wrapper,
    children: [t.jsxs("div", {
      className: o.header,
      children: [t.jsxs("div", {
        className: o.headerLeft,
        children: [t.jsx(a.Body1, {
          as: "button",
          className: s(o.button, i.calendarControlButton),
          onClick: function onClick() {
            return c(e === "months" ? "dates" : "months");
          },
          children: N(B[Intl.DateTimeFormat("en", {
            month: "short"
          }).format(r)])
        }), t.jsx(a.Body1, {
          as: "button",
          className: s(o.button, i.calendarControlButton),
          onClick: function onClick() {
            return c(e === "years" ? "dates" : "years");
          },
          children: w
        })]
      }), t.jsxs("div", {
        className: o.headerRight,
        children: [t.jsx(a.Body1, {
          as: "button",
          className: s(o.button, o.withIcon, i.calendarControlButton),
          onClick: function onClick() {
            return p(S);
          },
          children: t.jsx(n, {
            color: f.gray10,
            size: 16,
            icon: n.icons.outline.backArrow
          })
        }), t.jsx(a.Body1, {
          as: "button",
          className: s(o.button, o.withIcon, i.calendarControlButton),
          onClick: function onClick() {
            return p(k);
          },
          children: t.jsx(n, {
            color: f.gray10,
            size: 16,
            icon: n.icons.outline.forwardArrow
          })
        })]
      })]
    }), t.jsxs("div", {
      className: o.body,
      children: [e === "dates" && t.jsx(b, {
        date: r,
        isDateDisabled: x,
        selectedDate: l,
        onSelectDate: j
      }), e === "months" && t.jsx(u, {
        onSelect: h,
        date: r
      }), e === "years" && t.jsx(u, {
        onSelect: h,
        date: r,
        type: "years"
      })]
    })]
  });
};
export { E as DatePicker };